module.exports = __webpack_public_path__ + "img/epr-price@2x.8a031c32.webp";